import { render } from "./Locker.vue?vue&type=template&id=528c3f8c"
import script from "./Locker.vue?vue&type=script&lang=js"
export * from "./Locker.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__